module.exports = __webpack_public_path__ + "5441eb08871387b3eeb270018658b873.pdf";